/**
 * 一定時間の待機
 * @param ms 待機時間指定
 * @returns {Promise<any>}
 */
export const sleep = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms !== null && ms !== void 0 ? ms : 1500);
});
